/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StateEnum } from './stateEnum';
import { SupportTypeEnum } from './supportTypeEnum';
import { Tag } from './tag';
import { TeacherPortfolioRecordTypeEnum } from './teacherPortfolioRecordTypeEnum';

export interface PatchedTeacherTarget { 
    readonly id?: string;
    readonly created?: Date;
    readonly modified?: Date;
    title?: string;
    description?: string;
    /**
     * Odhadovaný termín naplnění cíle.
     */
    fulfillmentDate?: string;
    /**
     * Kolik času pedagog odhaduje na splnění tohoto cíle.
     */
    estimatedTime?: number;
    /**
     * Jaká forma podpory je k naplnění cíle potřeba.  * `financial` - Finance * `material` - Materiál * `organizational` - Organizační
     */
    supportType?: SupportTypeEnum;
    readonly competences?: Array<Tag>;
    competenceUuids?: Array<string>;
    readonly availableCompetences?: Array<Tag>;
    /**
     * V jakém stavu se cíl aktuálně nachází.  * `waiting` - Čeká * `in_process` - Probíhá * `finished` - Dokončeno * `incomplete` - Nedokončeno
     */
    state?: StateEnum;
    /**
     * Vyplňte pouze v případě, že cíl nebyl dokončen.
     */
    incompleteReason?: string;
    /**
     * Volitelně lze uvést, jaké aktivity se k cíli vztahují.
     */
    activitiesText?: string;
    recordType?: TeacherPortfolioRecordTypeEnum;
    plannedActivities?: Array<string>;
    readonly subtypeType?: string;
    readonly teacherFirstName?: string;
    readonly teacherLastName?: string;
    readonly teacherGroups?: Array<string>;
}